module.exports = __webpack_public_path__ + "img/illu-frog.1a589ad1.svg";